/**
 * Affilers partner cabinet design system entry.
 * Shared rules: docs/adr/0001-design-system.md
 * Mount once in App — feature modules reuse globals, do not redefine buttons/links/modals.
 */
import { GlobalTokensStyled } from './GlobalTokensStyled';
import { GlobalTypographyStyled } from './GlobalTypographyStyled';
import { GlobalButtonsStyled } from './GlobalButtonsStyled';
import { GlobalFormsStyled } from './GlobalFormsStyled';
import { GlobalLinksStyled } from './GlobalLinksStyled';
import { GlobalListsStyled } from './GlobalListsStyled';
import { GlobalModalStyled } from './GlobalModalStyled';
import { GlobalOverlaysStyled } from './GlobalOverlaysStyled';
import { GlobalAccordionStyled } from './GlobalAccordionStyled';
import { GlobalUtilsStyled } from './GlobalUtilsStyled';

export function GlobalStyles() {
    return (
        <>
            <GlobalTokensStyled />
            <GlobalTypographyStyled />
            <GlobalButtonsStyled />
            <GlobalFormsStyled />
            <GlobalLinksStyled />
            <GlobalListsStyled />
            <GlobalModalStyled />
            <GlobalOverlaysStyled />
            <GlobalAccordionStyled />
            <GlobalUtilsStyled />
        </>
    );
}

export {
    GlobalTokensStyled,
    GlobalTypographyStyled,
    GlobalButtonsStyled,
    GlobalFormsStyled,
    GlobalLinksStyled,
    GlobalListsStyled,
    GlobalModalStyled,
    GlobalOverlaysStyled,
    GlobalAccordionStyled,
    GlobalUtilsStyled,
};
